import Api from 'libs/api/index';

class UsersApi extends Api {
  constructor() {
    super('users');
  }
}

export default UsersApi;
